import { useNavigate, useParams } from 'react-router-dom';
import { useBoolean, useUnmount } from 'ahooks';
import { Button, Space } from 'antd';

import { snapStore } from 'containers/Snaps/Snap/store';

import { usePutRequest } from 'hooks';

import { SnapDetails, SnapState } from 'codegen';

export const NotDuplicateButton = () => {
  const status = snapStore((state) => state.status);

  let timeout: NodeJS.Timeout;
  const { snapId } = useParams();
  const navigate = useNavigate();

  const [isLoading, { setTrue, setFalse }] = useBoolean(false);

  const [handlePut] = usePutRequest<SnapDetails>({
    options: {
      onError: setTrue,
      onBefore: setFalse,
      onSuccess: () => {
        timeout = setTimeout(() => {
          navigate(0); // reload page
        }, 1500);
      },
    },
  });

  useUnmount(() => {
    clearTimeout(timeout);
  });

  const isDublicated = status === SnapState.DUPLICATE_RECEIPT;
  const isPotentialDublicate = status === SnapState.POTENTIAL_DUPLICATE;

  const button = (
    <Button
      size='small'
      loading={isLoading}
      onClick={() => handlePut({ callbackURL: `/snaps/details/${snapId}/deduplicate` })}
      className='border-[green] text-[green]'
    >
      Not Duplicate
    </Button>
  );

  if (!isPotentialDublicate && !isDublicated) {
    return null;
  }

  if (isPotentialDublicate) {
    return (
      <Space size={10}>
        {button}

        <Button
          danger
          size='small'
          loading={isLoading}
          onClick={() => handlePut({ callbackURL: `/snaps/details/${snapId}/duplicate` })}
        >
          Duplicate
        </Button>
      </Space>
    );
  }

  return button;
};
